export default __webpack_public_path__ + "static/media/stanthony.2c8e7298.jpg";